import Header from "@/components/hotel/Header";
import SubpageHero from "@/components/hotel/SubpageHero";
import TwinRoom from "@/components/hotel/TwinRoom";
import Footer from "@/components/hotel/Footer";
import SEO, { BASE_URL } from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const TwinRoomPage = () => {
  const { t } = useLanguage();
  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Zweibettzimmer"
        description="Gemütliches Zweibettzimmer im ESOS Hotel Quelle Bad Ragaz – zwei getrennte Betten für maximalen Komfort."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Zimmer", path: "/rooms" },
          { name: "Zweibettzimmer", path: "/rooms/twin" },
        ]}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "HotelRoom",
          name: "Zweibettzimmer",
          description: "Gemütliches Zweibettzimmer mit zwei getrennten Betten und Gemeinschaftsbad.",
          url: `${BASE_URL}/rooms/twin`,
          bed: [
            { "@type": "BedDetails", typeOfBed: "Einzelbett", numberOfBeds: 2 },
          ],
          occupancy: { "@type": "QuantitativeValue", minValue: 1, maxValue: 2 },
          amenityFeature: [
            { "@type": "LocationFeatureSpecification", name: "WLAN", value: true },
            { "@type": "LocationFeatureSpecification", name: "TV", value: true },
            { "@type": "LocationFeatureSpecification", name: "Parkplatz", value: true },
          ],
        }}
      />
      <Header />
      <SubpageHero title={t.subpageHeroes.twinRoom.title} subtitle={t.subpageHeroes.twinRoom.subtitle} />
      <TwinRoom />
      <Footer />
    </main>
  );
};

export default TwinRoomPage;
